import AppHeader from "./AppHeader/AppHeader";
import { BookingGetters } from "../../store/onlineBooking/getters";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { createTheme, Theme, ThemeProvider } from "@mui/material/styles";
import theme, { formatTheme } from "../../config/MuiColorThemes";

BasePageLayout.propTypes = {
  children: PropTypes.node,
  rootClasses: PropTypes.oneOf([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  headerClasses: PropTypes.oneOf([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  mainClasses: PropTypes.oneOf([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  footerClasses: PropTypes.oneOf([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};
export function BasePageLayout(props) {
  const dynamicPalette = formatTheme();
  const dynamicTheme = createTheme(dynamicPalette);
  const appSettings = BookingGetters.getAppSettings();
  const hideBackgroundImage = appSettings && appSettings["hideBackgroundImage"];
  const [redirectEnable, setRedirectEnable] = useState<boolean | undefined>(
    false
  );
  const [redirecttoHomePage, setRedirectToHomePagve] = useState<
    string | null | undefined
  >("");
  const [backgroundImageUrl, setBackgroundImageUrl] = useState<string>("");
  // const [backgroundImageUrl, setBackgroundImageUrl] = useState(
  //   appSettings?.config?.backgroundImageUrl || "/assets/images/bg-common.jpg"
  // );
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  useEffect(() => {
    setRedirectToHomePagve(appSettings?.redirectUrl);
    setRedirectEnable(appSettings?.redirectToHomePage);
    if (appSettings) {
      const customBg = appSettings?.config?.backgroundImageUrl?.trim();
      setBackgroundImageUrl(
        customBg && customBg.length > 0
          ? customBg
          : "/assets/images/bg-common.jpg"
      );
    }
    const logoUrl = appSettings && appSettings["config"]?.logoUrl;
    const companyName = appSettings && appSettings["companyName"];
    if (companyName != null) {
      document.title = companyName;
    }
    if (logoUrl != null) {
      const icon =
        document.querySelector('link[rel="icon"]') ||
        document.createElement("link");
      icon.href = logoUrl;
      icon.rel = "icon";
      document.head.appendChild(icon);
    }
    setIsInitialized(true);
  }, [appSettings]);
  useEffect(() => {
    if (
      redirectEnable &&
      redirecttoHomePage != null &&
      redirecttoHomePage != "" &&
      (window.location.pathname == "/" || window.location.pathname == "/embed")
    ) {
      window.location.href = redirecttoHomePage;
    }
  }, [redirecttoHomePage, redirectEnable]);

  const route = useLocation();
  return (
    <ThemeProvider theme={dynamicTheme}>
      <div
        className={`min-h-screen flex flex-col bg-cover  ${
          props.rootClasses || ""
        }`}
      >
        <div className={`text-white`}>
          <header
            className={`${props.headerClasses} sticky top-0 bg-white shadow-lg z-50`}
          >
            <AppHeader dynamicTheme={dynamicTheme}></AppHeader>
          </header>
          {isInitialized === true && (
            <main
              className={`grow bg-cover min-h-screen  ${props.mainClasses}`}
              style={{
                backgroundImage:
                  //                   !hideBackgroundImage && route.pathname === "/"
                  //                     ? `url(${
                  //                         backgroundImageUrl?.trim()
                  //                           ? backgroundImageUrl
                  //                           : "/assets/images/bg-common.jpg"
                  //                       })`
                  !hideBackgroundImage &&
                  (route.pathname === "/" || route.pathname === "/embed")
                    ? `url(${backgroundImageUrl})`
                    : "",
              }}
            >
              {props.children}
            </main>
          )}
        </div>
      </div>
    </ThemeProvider>
  );
}
